import { Icon, IconProps } from '@chakra-ui/react'

export function ControlBoardsIcon(props: IconProps) {
  return (
    <Icon viewBox="0 0 31 32" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.9587 4.5245H26.5615V2.91619H24.9587V4.5245ZM26.9108 5.22315H24.6094C24.4166 5.22315 24.2601 5.06666 24.2601 4.87383V2.56686C24.2601 2.37403 24.4166 2.21753 24.6094 2.21753H26.9108C27.1036 2.21753 27.2601 2.37403 27.2601 2.56686V4.87383C27.2601 5.06666 27.1036 5.22315 26.9108 5.22315Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.55478 14.4077H12.2585V8.70399H6.55478V14.4077ZM12.608 15.1064H6.20565C6.01282 15.1064 5.85632 14.9499 5.85632 14.7571V8.3547C5.85632 8.16187 6.01282 8.00537 6.20565 8.00537H12.608C12.8008 8.00537 12.9573 8.16187 12.9573 8.3547V14.7571C12.9573 14.9499 12.8008 15.1064 12.608 15.1064Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.13226 10.1263C8.04842 10.1263 7.97716 10.1976 7.97716 10.2814V12.8301C7.97716 12.914 8.04842 12.9852 8.13226 12.9852H10.681C10.7648 12.9852 10.8347 12.914 10.8347 12.8301V10.28C10.8347 10.1962 10.7634 10.1249 10.6796 10.1249H8.13086L8.13226 10.1263ZM10.681 13.6839H8.13226C7.66136 13.6839 7.2785 13.301 7.2785 12.8301V10.28C7.2785 9.80913 7.66136 9.42627 8.13226 9.42627H10.681C11.1519 9.42627 11.5333 9.80913 11.5333 10.28V12.8287C11.5333 13.2996 11.1505 13.6825 10.681 13.6825V13.6839Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.9913 10.1666H12.6079C12.4151 10.1666 12.2586 10.0101 12.2586 9.81724C12.2586 9.62441 12.4151 9.46791 12.6079 9.46791H13.7887L14.4552 8.31371C14.5516 8.14603 14.7654 8.09014 14.9317 8.18655C15.0994 8.28297 15.1566 8.49676 15.0602 8.66303L14.2931 9.99186C14.2302 10.0995 14.1157 10.1665 13.9899 10.1665L13.9913 10.1666Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.7585 14.9736C14.6384 14.9736 14.521 14.9107 14.4553 14.7989L13.7888 13.6447H12.6081C12.4152 13.6447 12.2587 13.4882 12.2587 13.2954C12.2587 13.1025 12.4152 12.946 12.6081 12.946H13.9914C14.1172 12.946 14.2317 13.0131 14.2946 13.1207L15.0617 14.4495C15.1582 14.6172 15.1009 14.831 14.9332 14.9274C14.8787 14.9596 14.8186 14.9749 14.7599 14.9749L14.7585 14.9736Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.071 11.9052H12.6095C12.4166 11.9052 12.2601 11.7487 12.2601 11.5559C12.2601 11.363 12.4166 11.2065 12.6095 11.2065H14.071C14.2639 11.2065 14.4204 11.363 14.4204 11.5559C14.4204 11.7487 14.2639 11.9052 14.071 11.9052Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.20525 10.1667H4.8219C4.69614 10.1667 4.58156 10.0996 4.51868 9.992L3.75156 8.66316C3.65515 8.49548 3.71244 8.28309 3.88012 8.18669C4.0464 8.09027 4.26019 8.14756 4.3566 8.31524L5.02312 9.46944H6.20386C6.39669 9.46944 6.55319 9.62594 6.55319 9.81877C6.55319 10.0116 6.39669 10.1681 6.20386 10.1681L6.20525 10.1667Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.05504 14.9737C3.99635 14.9737 3.93627 14.9583 3.88177 14.9262C3.71409 14.8298 3.6568 14.616 3.75321 14.4483L4.52033 13.1195C4.58321 13.0119 4.69779 12.9448 4.82355 12.9448H6.2069C6.39973 12.9448 6.55623 13.1013 6.55623 13.2942C6.55623 13.487 6.39973 13.6435 6.2069 13.6435H5.02616L4.35963 14.7977C4.29535 14.9095 4.17798 14.9723 4.05641 14.9723L4.05504 14.9737Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.20526 11.9052H4.74368C4.55085 11.9052 4.39435 11.7487 4.39435 11.5559C4.39435 11.363 4.55085 11.2065 4.74368 11.2065H6.20526C6.39809 11.2065 6.55459 11.363 6.55459 11.5559C6.55459 11.7487 6.39809 11.9052 6.20526 11.9052Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.1449 8.70393C10.9521 8.70393 10.7956 8.54743 10.7956 8.3546V6.97125C10.7956 6.84689 10.8613 6.73091 10.9689 6.66943L12.2977 5.90231C12.4654 5.8059 12.6778 5.86318 12.7756 6.02947C12.872 6.19715 12.8147 6.40954 12.647 6.50734L11.4928 7.17387V8.356C11.4928 8.54883 11.3363 8.70533 11.1435 8.70533L11.1449 8.70393Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.66831 8.70389C7.47408 8.70389 7.31898 8.54739 7.31898 8.35456V7.17242L6.16478 6.50589C5.9985 6.40948 5.94121 6.19569 6.03763 6.02942C6.13404 5.86174 6.34783 5.80445 6.5141 5.90226L7.84293 6.66938C7.95053 6.73226 8.0176 6.84684 8.0176 6.9712V8.35455C8.0176 8.54738 7.86114 8.70389 7.66831 8.70389Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.40682 8.70387C9.21399 8.70387 9.0575 8.54737 9.0575 8.35454V6.89157C9.0575 6.69874 9.21399 6.54224 9.40682 6.54224C9.59965 6.54224 9.75615 6.69874 9.75615 6.89157V8.35315C9.75615 8.54598 9.59965 8.70248 9.40682 8.70248V8.70387Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.4738 17.2568C12.4151 17.2568 12.3536 17.2415 12.2992 17.2093L10.9703 16.4422C10.8627 16.3793 10.7957 16.2648 10.7957 16.1404V14.757C10.7957 14.5642 10.9508 14.4077 11.1436 14.4077C11.3378 14.4077 11.4929 14.5642 11.4929 14.757V15.9378L12.6471 16.6043C12.8134 16.7007 12.8707 16.9145 12.7757 17.0822C12.7114 17.194 12.5926 17.2568 12.4725 17.2568L12.4738 17.2568Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.33938 17.2568C6.21921 17.2568 6.10184 17.1939 6.03616 17.0821C5.93975 16.9144 5.99703 16.702 6.16332 16.6042L7.31752 15.9377V14.7556C7.31752 14.5628 7.47262 14.4062 7.66685 14.4062C7.85968 14.4062 8.01617 14.5628 8.01617 14.7556V16.1389C8.01617 16.2633 7.9491 16.3793 7.84151 16.4421L6.51268 17.2093C6.45818 17.2414 6.39807 17.2568 6.33938 17.2568Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.40682 16.5694C9.21399 16.5694 9.0575 16.4129 9.0575 16.22V14.757C9.0575 14.5642 9.21399 14.4077 9.40682 14.4077C9.59965 14.4077 9.75615 14.5642 9.75615 14.757V16.2186C9.75615 16.4115 9.59965 16.568 9.40682 16.568V16.5694Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.104 2.91625C15.8231 2.91625 15.5953 3.14401 15.5953 3.42349C15.5953 3.70296 15.8231 3.93073 16.104 3.93073C16.3848 3.93073 16.6126 3.70296 16.6126 3.42349C16.6126 3.14401 16.3848 2.91625 16.1053 2.91625H16.104ZM16.104 4.63077C15.4388 4.63077 14.8967 4.09002 14.8967 3.42488C14.8967 2.75975 15.4388 2.21899 16.104 2.21899C16.7691 2.21899 17.3112 2.75975 17.3112 3.42488C17.3112 4.09002 16.7705 4.63077 16.1053 4.63077H16.104Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.2335 2.91625C11.954 2.91625 11.7262 3.14401 11.7262 3.42349C11.7262 3.70296 11.954 3.93073 12.2335 3.93073C12.5143 3.93073 12.7421 3.70296 12.7421 3.42349C12.7421 3.14401 12.5143 2.91625 12.2335 2.91625ZM12.2335 4.63077C11.5683 4.63077 11.0276 4.09002 11.0276 3.42488C11.0276 2.75975 11.5683 2.21899 12.2335 2.21899C12.8986 2.21899 13.4408 2.75975 13.4408 3.42488C13.4408 4.09002 12.8986 4.63077 12.2335 4.63077Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.36446 2.91625C8.08499 2.91625 7.85722 3.14401 7.85722 3.42349C7.85722 3.70296 8.08498 3.93073 8.36446 3.93073C8.64532 3.93073 8.87309 3.70296 8.87309 3.42349C8.87309 3.14401 8.64533 2.91625 8.36585 2.91625H8.36446ZM8.36446 4.63077C7.69933 4.63077 7.15857 4.09002 7.15857 3.42488C7.15857 2.75975 7.69933 2.21899 8.36446 2.21899C9.02959 2.21899 9.57174 2.75975 9.57174 3.42488C9.57174 4.09002 9.02959 4.63077 8.36585 4.63077H8.36446Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.4936 2.91625C4.21274 2.91625 3.98497 3.14401 3.98497 3.42349C3.98497 3.70296 4.21273 3.93073 4.4936 3.93073C4.77306 3.93073 5.00084 3.70296 5.00084 3.42349C5.00084 3.14401 4.77307 2.91625 4.4936 2.91625ZM4.4936 4.63077C3.82847 4.63077 3.28632 4.09002 3.28632 3.42488C3.28632 2.75975 3.82707 2.21899 4.4936 2.21899C5.15873 2.21899 5.69949 2.75975 5.69949 3.42488C5.69949 4.09002 5.15873 4.63077 4.4936 4.63077Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.4196 17.0627H22.7344V6.45009H21.4196V17.0627ZM23.0838 17.7614H21.0702C20.876 17.7614 20.7209 17.6049 20.7209 17.4121V6.10079C20.7209 5.90796 20.876 5.75146 21.0702 5.75146H23.0838C23.2766 5.75146 23.4331 5.90796 23.4331 6.10079V17.4121C23.4331 17.6049 23.2766 17.7614 23.0838 17.7614Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.2289 17.0627H18.5452V6.45009H17.2289V17.0627ZM18.8931 17.7614H16.8796C16.6868 17.7614 16.5303 17.6049 16.5303 17.4121V6.10079C16.5303 5.90796 16.6868 5.75146 16.8796 5.75146H18.8931C19.0874 5.75146 19.2425 5.90796 19.2425 6.10079V17.4121C19.2425 17.6049 19.086 17.7614 18.8931 17.7614Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.9997 7.69202C25.6895 7.69202 25.4366 7.94494 25.4366 8.25514C25.4366 8.56534 25.6895 8.81825 25.9997 8.81825C26.3099 8.81825 26.5629 8.56534 26.5629 8.25514C26.5629 7.94493 26.3099 7.69202 25.9997 7.69202ZM25.9997 9.51694C25.3039 9.51694 24.738 8.95103 24.738 8.25517C24.738 7.55931 25.3039 6.99341 25.9997 6.99341C26.6956 6.99341 27.2615 7.55931 27.2615 8.25517C27.2615 8.95103 26.6956 9.51694 25.9997 9.51694Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.9997 11.1937C25.6895 11.1937 25.4366 11.4466 25.4366 11.7568C25.4366 12.067 25.6895 12.3199 25.9997 12.3199C26.3099 12.3199 26.5629 12.067 26.5629 11.7568C26.5629 11.4466 26.3099 11.1937 25.9997 11.1937ZM25.9997 13.0172C25.3039 13.0172 24.738 12.4513 24.738 11.7554C24.738 11.0596 25.3039 10.4937 25.9997 10.4937C26.6956 10.4937 27.2615 11.0596 27.2615 11.7554C27.2615 12.4513 26.6956 13.0172 25.9997 13.0172Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.9997 14.6967C25.6895 14.6967 25.4366 14.9496 25.4366 15.2598C25.4366 15.57 25.6895 15.8229 25.9997 15.8229C26.3099 15.8229 26.5629 15.57 26.5629 15.2598C26.5629 14.9496 26.3099 14.6967 25.9997 14.6967ZM25.9997 16.5216C25.3039 16.5216 24.738 15.9557 24.738 15.2598C24.738 14.5639 25.3039 13.998 25.9997 13.998C26.6956 13.998 27.2615 14.5639 27.2615 15.2598C27.2615 15.9557 26.6956 16.5216 25.9997 16.5216Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.0323 25.9521H26.5615V23.416H24.0323V25.9521ZM26.9108 26.6508H23.683C23.4902 26.6508 23.3337 26.4942 23.3337 26.3014V23.0666C23.3337 22.8738 23.4902 22.7173 23.683 22.7173H26.9108C27.1036 22.7173 27.2601 22.8738 27.2601 23.0666V26.3014C27.2601 26.4942 27.1036 26.6508 26.9108 26.6508Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.2982 26.6508C25.1054 26.6508 24.9489 26.4943 24.9489 26.3015V24.6848C24.9489 24.4919 25.1054 24.3354 25.2982 24.3354C25.4911 24.3354 25.6476 24.4919 25.6476 24.6848V26.3015C25.6476 26.4943 25.4911 26.6508 25.2982 26.6508Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.6891 25.9521H21.2183V23.416H18.6891V25.9521ZM21.5676 26.6508H18.3398C18.147 26.6508 17.9905 26.4942 17.9905 26.3014V23.0666C17.9905 22.8738 18.147 22.7173 18.3398 22.7173H21.5676C21.7604 22.7173 21.9169 22.8738 21.9169 23.0666V26.3014C21.9169 26.4942 21.7604 26.6508 21.5676 26.6508Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.9536 26.6508C19.7608 26.6508 19.6043 26.4943 19.6043 26.3015V24.6848C19.6043 24.4919 19.7608 24.3354 19.9536 24.3354C20.1479 24.3354 20.303 24.4919 20.303 24.6848V26.3015C20.303 26.4943 20.1479 26.6508 19.9536 26.6508Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.98635 25.9968H14.8269V24.8161H3.98635V25.9968ZM15.176 26.6955H3.63687C3.44404 26.6955 3.28754 26.539 3.28754 26.3462V24.4668C3.28754 24.2739 3.44404 24.1174 3.63687 24.1174H15.176C15.3688 24.1174 15.5253 24.2739 15.5253 24.4668V26.3462C15.5253 26.539 15.3688 26.6955 15.176 26.6955Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.98635 22.0859H14.8269V20.9052H3.98635V22.0859ZM15.176 22.7846H3.63687C3.44404 22.7846 3.28754 22.6281 3.28754 22.4353V20.5559C3.28754 20.363 3.44404 20.2065 3.63687 20.2065H15.176C15.3688 20.2065 15.5253 20.363 15.5253 20.5559V22.4353C15.5253 22.6281 15.3688 22.7846 15.176 22.7846Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.8631 29.7838C25.6702 29.7838 25.5137 29.6273 25.5137 29.4344V28.3515C25.5137 28.1587 25.6702 28.0022 25.8631 28.0022C26.0559 28.0022 26.2124 28.1587 26.2124 28.3515V29.433C26.2124 29.6259 26.0559 29.7824 25.8631 29.7824V29.7838Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.3938 29.7838C23.2009 29.7838 23.0444 29.6273 23.0444 29.4344V28.3515C23.0444 28.1587 23.2009 28.0022 23.3938 28.0022C23.5866 28.0022 23.7431 28.1587 23.7431 28.3515V29.433C23.7431 29.6259 23.5866 29.7824 23.3938 29.7824V29.7838Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.9234 29.7838C20.7306 29.7838 20.5741 29.6273 20.5741 29.4344V28.3515C20.5741 28.1587 20.7306 28.0022 20.9234 28.0022C21.1177 28.0022 21.2728 28.1587 21.2728 28.3515V29.433C21.2728 29.6259 21.1177 29.7824 20.9234 29.7824V29.7838Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.4544 29.7838C18.2616 29.7838 18.1051 29.6273 18.1051 29.4344V28.3515C18.1051 28.1587 18.2616 28.0022 18.4544 28.0022C18.6473 28.0022 18.8038 28.1587 18.8038 28.3515V29.433C18.8038 29.6259 18.6473 29.7824 18.4544 29.7824V29.7838Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.9852 29.7838C15.7924 29.7838 15.6359 29.6273 15.6359 29.4344V28.3515C15.6359 28.1587 15.7924 28.0022 15.9852 28.0022C16.178 28.0022 16.3345 28.1587 16.3345 28.3515V29.433C16.3345 29.6259 16.178 29.7824 15.9852 29.7824V29.7838Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.5148 29.7838C13.322 29.7838 13.1655 29.6273 13.1655 29.4344V28.3515C13.1655 28.1587 13.322 28.0022 13.5148 28.0022C13.7076 28.0022 13.8641 28.1587 13.8641 28.3515V29.433C13.8641 29.6259 13.7076 29.7824 13.5148 29.7824V29.7838Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.0459 29.7838C10.853 29.7838 10.6965 29.6273 10.6965 29.4344V28.3515C10.6965 28.1587 10.853 28.0022 11.0459 28.0022C11.2387 28.0022 11.3952 28.1587 11.3952 28.3515V29.433C11.3952 29.6259 11.2387 29.7824 11.0459 29.7824V29.7838Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.57656 29.7838C8.38373 29.7838 8.22723 29.6273 8.22723 29.4344V28.3515C8.22723 28.1587 8.38373 28.0022 8.57656 28.0022C8.76939 28.0022 8.92589 28.1587 8.92589 28.3515V29.433C8.92589 29.6259 8.76939 29.7824 8.57656 29.7824V29.7838Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.10617 29.7838C5.91334 29.7838 5.75684 29.6273 5.75684 29.4344V28.3515C5.75684 28.1587 5.91334 28.0022 6.10617 28.0022C6.30039 28.0022 6.45549 28.1587 6.45549 28.3515V29.433C6.45549 29.6259 6.29899 29.7824 6.10617 29.7824V29.7838Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.63723 29.7838C3.4444 29.7838 3.2879 29.6273 3.2879 29.4344V28.3515C3.2879 28.1587 3.4444 28.0022 3.63723 28.0022C3.83006 28.0022 3.98656 28.1587 3.98656 28.3515V29.433C3.98656 29.6259 3.83006 29.7824 3.63723 29.7824V29.7838Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.65711 17.8213C4.37625 17.8213 4.14848 18.049 4.14848 18.3285C4.14848 18.608 4.37624 18.8358 4.65711 18.8358C4.93798 18.8358 5.16575 18.608 5.16575 18.3285C5.16575 18.049 4.93798 17.8213 4.65851 17.8213H4.65711ZM4.65711 19.5358C3.99198 19.5358 3.44983 18.995 3.44983 18.3299C3.44983 17.6648 3.99059 17.124 4.65711 17.124C5.32225 17.124 5.8644 17.6648 5.8644 18.3299C5.8644 18.995 5.32225 19.5358 4.65851 19.5358H4.65711Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.1576 17.5867C13.8767 17.5867 13.649 17.8144 13.649 18.0939C13.649 18.3734 13.8767 18.6011 14.1576 18.6011C14.4385 18.6011 14.6662 18.3734 14.6662 18.0939C14.6662 17.8144 14.4385 17.5867 14.159 17.5867H14.1576ZM14.1576 19.3012C13.4925 19.3012 12.9503 18.7604 12.9503 18.0953C12.9503 17.4302 13.4911 16.8894 14.1576 16.8894C14.8227 16.8894 15.3649 17.4302 15.3649 18.0953C15.3649 18.7604 14.8227 19.3012 14.159 19.3012H14.1576Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.9747 2.91625C19.6939 2.91625 19.4661 3.14401 19.4661 3.42349C19.4661 3.70296 19.6939 3.93073 19.9747 3.93073C20.2556 3.93073 20.4834 3.70296 20.4834 3.42349C20.4834 3.14401 20.2556 2.91625 19.9761 2.91625H19.9747ZM19.9747 4.63077C19.3096 4.63077 18.7675 4.09002 18.7675 3.42488C18.7675 2.75975 19.3082 2.21899 19.9747 2.21899C20.6399 2.21899 21.182 2.75975 21.182 3.42488C21.182 4.09002 20.6413 4.63077 19.9761 4.63077H19.9747Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.63904 0.698615C1.12065 0.698615 0.698651 1.12061 0.698651 1.63901V30.3609C0.698651 30.8793 1.12065 31.3013 1.63904 31.3013H28.909C29.4274 31.3013 29.8494 30.8793 29.8494 30.3609V1.63901C29.8494 1.12061 29.4274 0.698615 28.909 0.698615H1.63904ZM28.909 32H1.63904C0.734995 32 0 31.265 0 30.361V1.63904C0 0.734994 0.734995 0 1.63904 0H28.909C29.813 0 30.548 0.734994 30.548 1.63904V30.361C30.548 31.265 29.813 32 28.909 32Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.9108 21.4514C26.718 21.4514 26.5615 21.2949 26.5615 21.102V19.8137C26.5615 19.6209 26.718 19.4644 26.9108 19.4644C27.1036 19.4644 27.2601 19.6209 27.2601 19.8137V21.102C27.2601 21.2949 27.1036 21.4514 26.9108 21.4514Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.7688 21.4514C24.576 21.4514 24.4195 21.2949 24.4195 21.102V19.8137C24.4195 19.6209 24.576 19.4644 24.7688 19.4644C24.9617 19.4644 25.1182 19.6209 25.1182 19.8137V21.102C25.1182 21.2949 24.9617 21.4514 24.7688 21.4514Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.6269 21.4514C22.4326 21.4514 22.2775 21.2949 22.2775 21.102V19.8137C22.2775 19.6209 22.4326 19.4644 22.6269 19.4644C22.8197 19.4644 22.9762 19.6209 22.9762 19.8137V21.102C22.9762 21.2949 22.8197 21.4514 22.6269 21.4514Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.4831 21.4514C20.2902 21.4514 20.1337 21.2949 20.1337 21.102V19.8137C20.1337 19.6209 20.2902 19.4644 20.4831 19.4644C20.6773 19.4644 20.8324 19.6209 20.8324 19.8137V21.102C20.8324 21.2949 20.6773 21.4514 20.4831 21.4514Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.3396 21.4514C18.1468 21.4514 17.9903 21.2949 17.9903 21.102V19.8137C17.9903 19.6209 18.1468 19.4644 18.3396 19.4644C18.5325 19.4644 18.689 19.6209 18.689 19.8137V21.102C18.689 21.2949 18.5325 21.4514 18.3396 21.4514Z"
        fill="currentColor"
      />

    </Icon>
  )
}
